<template>
  <div style="min-height: 750px;" v-if="d_frdWdm">
    <template v-if="d_pageShow">
      <b-row>
        <b-col sm="12" lg="2"></b-col>
        <b-col sm="12" lg="8"></b-col>
        <b-col sm="12" lg="2"></b-col>
      </b-row>
      <b-row style="margin-bottom: 20px; border-bottom: solid 1px whitesmoke;">
        <b-col sm="12" md="2" lg="2"> </b-col>
        <b-col sm="12" md="4" lg="4">
          <i class="fa fa-desktop"></i>
          {{ StoreLangTranslation.data['exchange_rate'][StoreLang] }}
        </b-col>
        <b-col sm="12" md="4" lg="4" :style="StoreDevice.isMobile ? '' : 'text-align: right;'"></b-col>
        <b-col sm="12" md="2" lg="2">
        </b-col>
      </b-row>
      <b-row style="font-size: 16px;">
        <b-col sm="12" lg="2"></b-col>
        <b-col sm="12" lg="8">
          <template v-if="d_frontendLoading">
            <b-spinner variant="primary" label="Spinning"></b-spinner>
          </template>
          <template>
            <b-card-header header-bg-variant="white" header-text-variant="dark" style="margin-bottom: 10px;">
              <b-row>
                <b-col sm="12" lg="8">
                  <h6>
                    <i class="fa fa-calculator"></i>
                    {{ StoreLangTranslation.data['exchange_rates'][StoreLang] }}
                  </h6>
                </b-col>
                <b-col sm="12" lg="4" style="text-align: right;"></b-col>
              </b-row>
            </b-card-header>
            <b-card-body >
              <b-row v-for="currency in f_filteredExchangeData" :key="currency" style="margin: 3px; border-bottom: solid 1px whitesmoke;">
                <b-col sm="12" lg="4">
                  <p>{{ currency }} -> {{ f_currentBaseCurrency }}</p>
                  
                </b-col>
                <b-col sm="12" lg="4">
                  {{ StoreLangTranslation.data['exchange_rate'][StoreLang] }}
                  <b-row style="margin: 3px;">
                    {{ f_currentExchangeRates[currency] }}
                  </b-row>
                </b-col>
                <b-col  sm="12" lg="4">
                  {{ StoreLangTranslation.data['cur_update_time'][StoreLang] }}
                  <b-row style="margin: 3px;">
                    {{d_exchange_data.updated_time}}
                  </b-row>
                </b-col>
              </b-row>
            </b-card-body>
            
          </template>
        </b-col>
        <b-col sm="12" lg="2"></b-col>
      </b-row>
    </template>


  </div>
</template>

<script>

import { ClsUser } from '@/wam/modules/user';

import { API_BASE_URL } from '@/config';
import { ServiceFunctions } from '@/wam/modules/service';
import { ClsWdm } from '@/wam/modules/wdm';
import store from '@/store';
import {
  default as Page404
} from '@/wam/components/widgets/Page404';
import {
  default as Login
} from '@/wam/views/login';
import { mapGetters } from 'vuex';
export default {
  name: 'frontend_settings',
  computed: {...mapGetters({
      StoreDevice: 'StoreDevice',
      StoreFrontendSettings: 'StoreFrontendSettings',
      StoreLang: 'StoreLang',
      StoreLangTranslation: 'StoreLangTranslation',
      StoreLangList: 'StoreLangList',
      StoreCurrencyType: 'StoreCurrencyType',
    }),
      f_filteredExchangeData() {       
         return Object.keys(this.f_currentExchangeRates)
           .filter(key => this.f_currentExchangeRates[key])
           .sort((a, b) => {
             if (a === "USD") return -1;
             if (b === "USD") return 1;
             if (a === "EUR") return -1;
             if (b === "EUR") return 1;
             if (a =='TL') return -1;
             if (b == 'TL') return 1;
             return a.localeCompare(b);
          });
      },  
      f_currentBaseCurrency() {
        if (
          !this.d_exchange_data ||
          !this.d_exchange_data.system ||
          this.StoreCurrencyType == null
        ) {
          return null;
        }
      
        return this.d_exchange_data.system[this.StoreCurrencyType.value];
      },  
      f_currentExchangeRates() {
        if (
          !this.f_currentBaseCurrency ||
          !this.d_exchange_data[this.f_currentBaseCurrency]
        ) {
          return {};
        }
      
        return this.d_exchange_data[this.f_currentBaseCurrency];
      },    
    },
  components: {
    Page404,
    Login,
  },
  props: {},
  data () {
    return {
      d_exchange_data: {},
      page_cur_type:'',
      d_systemDocumentList: [],
      d_imageUploadModal: false,
      d_fullScreen: false,
      d_tmpFile: null,
      d_showPassword: {
        'mail_smtp_password': false,
        'worganization_api_username': false,
        'worganization_api_password': false,
        'worganization_token': false,
        'register_mail_approve_mail_from_password': false,
        'mail_api_token_username': false,
        'mail_api_token_password': false,
        'waccount_password': false,
        'support_mail_from_password': false,
      },
      d_frdWdm: '',
      d_frontendData: {
        'application_name': {},
        'are_shop_pages_active': '',
        'login_background_color': '',
        'login_buttons_background_color': '',
        'login_card_in_background_color': '',
        'login_card_in_shadow_color': '',
        'login_card_out_background_color': '',
        'login_card_out_shadow_color': '',
        'login_function': '',
        'register_function': '',
        'login_function_external': '',
        'login_inputs_border_color': '',
        'login_loading_background_color': '',
        'login_slogan_text': {},
        'mail_api_send_mail_uri': '',
        'mail_api_token_password': '',
        'mail_api_token_uri': '',
        'mail_api_token_username': '',
        'menu_background_color': '',
        'menu_border_bottom_color': '',
        'menu_box_shadow_color': '',
        'menu_child_item_background_color': '',
        'menu_child_item_border_bottom_color': '',
        'menu_child_item_text_color': '',
        'navbar_application_name_color': '',
        'menu_parent_item_background_color': '',
        'menu_parent_item_border_bottom_color': '',
        'menu_parent_item_text_color': '',
        'menu_top_caption': {},
        'menu_type': '',
        'meta': '',
        'meta_value': '',
        'navbar_application_name_shadow_color': '',
        'navbar_background_color': '',
        'password_reset_mail_approve_frontend_uri_and_route': {},
        'password_reset_mail_approve_link_text': {},
        'password_reset_mail_approve_subject': {},
        'privacy_policy_link': {},
        'register_mail_approve_frontend_uri_and_route': {},
        'register_mail_approve_link_text': {},
        'register_mail_approve_mail_from': '',
        'register_mail_approve_mail_from_password': '',
        'register_mail_approve_subject': {},
        'mail_privacy_notice_text': {},
        'mail_smtp_address': '',
        'mail_smtp_username': '',
        'mail_smtp_password': '',
        'status': '',
        'terms_of_service_link': {},
        'wanalyzer_api_password': '',
        'wanalyzer_api_url': '',
        'wanalyzer_api_username': '',
        'wanalyzer_frontend_url': '',
        'wmanager_uri': '',
        'worganization_api_password': '',
        'worganization_api_url': '',
        'worganization_api_username': '',
        'worganization_frontend_url': '',
        'worganization_organizasyon_id_values': '',
        'worganization_token': '',
        'waccount_external_key': '',
        'waccount_url': '',
        'waccount_username': '',
        'waccount_password': '',
        'waccount_system_product_id': '',
        'worganization_user_id': '',
        'application_frontend_uri': '',
        'application_backend_uri': '',
        'support_details_subject': {},
        'support_mail_from': '',
        'support_mail_from_password': '',
        'support_details_link_text': {},
        'support_details_frontend_uri_and_route': {},
        'page_area_text_color': {},
        'footer_text_color': {},
        'footer_background_color': {},
        'navbar_text_color': {},
        'facebook_link': {},
        'twitter_link': {},
        'instagram_link': {},
        'linkedin_link': {},
        'login_background_image': {},
        'footer_date': '',
        'navbar_flowing_text': {},
        'footer_date': '',
        'footer_text_padding': '',
        'footer_text_size': '',
        'footer_text_weight': '',
        'general_font_select': '',
        'general_font_size': '',
        'general_font_style': '',
        'general_font_weight': '',
        'general_text_color': '',
        'language_options': [],
        'market_visiblity_type': '',
        'navbar_font_size': '',
        'navbar_text_weight': '',
        'page_favicon': '',
        'default_language': '',
        'language_change_button_visibility': '',
        'google_analytics_id': '',
        'google_recaptcha_key': '',
        'login_button_name': {},
        'language_change_button_type': '',
        'domain': '',
        'package_groups_to_show_in_shop': {},
        'shop_view': '',
        'users_can_upload_dataset': '',
        'wanalyzer_credit_usage': '',
        'support_management_type': '',
      },
      d_user: '',
      d_eligiblePermissionList: ['admin'],
      d_pageShow: false,
      d_frontendLoading: false,
    };
  },
  created: function () {
    let user_perm_eligible = false;
    ClsWdm.getLayerWdm('frd').then(resp_wdm_data => { this.d_frdWdm = resp_wdm_data; });
    this.d_user = JSON.parse(localStorage.getItem('user'));
    user_perm_eligible = ClsUser.f_checkUserAuth(['admin']);
    if (user_perm_eligible) {
      this.d_pageShow = true;
      this.f_langEligibleParameterProcess();
      // this.d_frontendData = JSON.parse(JSON.stringify(this.StoreFrontendSettings.data));
      this.f_getFrontendSettings();
      // console.log('this.d_frontendData.menu_type', this.d_frontendData.menu_type);
      // console.log(JSON.stringify(this.d_frontendData));

    } else {
      this.$router.push({ path: this.StoreLangTranslation.data['page_404_path'][this.StoreLang], query: {} });
    }
    this.f_getExchangeCurData();
  },
  beforeMount () {},
  mounted: function () {},
  methods: {
    f_getExchangeCurData(){
      ServiceFunctions.get_exchange_cur_data().then(resp => {
        if (resp.data.status_code.slice(-3)==='000') {
          this.d_exchange_data = resp.data;
        }
      })
      .catch(error => {
        console.log("API error:", error)
        })

    },     
    d_fullScreenLogin: function () {
      if (this.d_fullScreen) {
        let height = window.innerHeight - 200;
        return 'overflow-y: auto; height: ' + height.toString() + 'px; top: 120px; left: 10px; right: 10px; position: fixed; z-index: 1000;';
      } else {
        return 'overflow-y: auto; overflow-x: auto; height: 500px; margin-right: 10px; margin-left: 10px;';
      }
    },
    f_langEligibleParameterProcess: function () {
      let lang_eligible_variables = ['application_name', 'login_slogan_text', 'menu_top_caption', 'password_reset_mail_approve_frontend_uri_and_route', 'password_reset_mail_approve_link_text', 'password_reset_mail_approve_subject', 'privacy_policy_link', 'register_mail_approve_frontend_uri_and_route', 'register_mail_approve_link_text', 'register_mail_approve_subject', 'terms_of_service_link', 'support_details_subject', 'support_details_link_text', 'support_details_frontend_uri_and_route', 'mail_privacy_notice_text', 'navbar_flowing_text', 'login_button_name', 'package_groups_to_show_in_shop'];
      for (let k in lang_eligible_variables) {
        for (let lang_index in this.StoreLangList.data) {
          if (!this.d_frontendData[lang_eligible_variables[k]][this.StoreLangList.data[lang_index].label]) {
            this.d_frontendData[lang_eligible_variables[k]][this.StoreLangList.data[lang_index].label] = '';
          }
        }
      }
    },
    f_getFrontendSettings: function () {
      let query = 'ss=1';
      let data = {};
      this.d_frontendLoading = true;
      ServiceFunctions.frontend_get(query, data)
        .then(resp => {
          this.d_frontendLoading = false;
          if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
            this.d_frontendData = resp.data.frontend;
            this.$store.commit('MutationFrontendSettings', { 'status': 1, 'data': this.d_frontendData });
          } else {
            alert(resp.data.status_code + ' = ' + resp.data.status_message);
          }
        });
    },
    f_saveFrontendSettings: function () {
      let query = '';
      let data = { 'frontend': this.d_frontendData };
      this.d_frontendLoading = true;
      ServiceFunctions.frontend_save(query, data)
        .then(resp => {
          this.d_frontendLoading = false;
          if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
            alert(this.StoreLangTranslation.data['process_completed'][this.StoreLang]);
          } else {
            alert(resp.data.status_code + ' = ' + resp.data.status_message);
          }
        });

    },
    f_applyFrontendSettings: function () {
      // console.log('this.d_frontendData.menu_background_color : ', this.d_frontendData.menu_background_color);
      this.$store.commit('MutationFrontendSettings', { 'status': 1, 'data': JSON.parse(JSON.stringify(this.d_frontendData)) });
    }
  },
  watch: {
    'd_frontendData.language_options': function () {
      let all_language_options = this.d_frdWdm['0']['parameters']['87']['options'];
      let use_lang_list = [];
      for (let lang of all_language_options) {
        if (this.d_frontendData.language_options.indexOf(lang.value) !== -1) {
          use_lang_list.push(lang);
        }
      }
      this.$store.commit('MutationLangList', { 'status': 1, 'data': use_lang_list });
      this.f_applyFrontendSettings();
    },
    'd_frontendData.market_visiblity_type': function () {
      this.f_applyFrontendSettings();
    },
    'd_frontendData.navbar_font_size': function () {
      this.f_applyFrontendSettings();
    },
    'd_frontendData.navbar_text_weight': function () {
      this.f_applyFrontendSettings();
    },
    'd_frontendData.page_favicon': function () {
      this.f_applyFrontendSettings();
    },
    'd_frontendData.default_language': function () {
      this.f_applyFrontendSettings();
    },
    'd_frontendData.language_change_button_visibility': function () {
      this.f_applyFrontendSettings();
    },
  }
};

</script>

